export const getAdditionalEntryDialoguesMap = (): Record<string, any> => {
    return {};
};
